/**
 * Created by vtbelo on 12.04.18.
 */

const LeaguesUpgradeWindow = CleverappsWindow.extend({
    onWindowLoaded: function () {
        cleverapps.metrics.logEvent(cleverapps.EVENTS.NEW_LEAGUE);

        const styles = cleverapps.styles.LeaguesUpgradeWindow;

        const text = this.createText();

        const content = new cc.Node();
        content.setAnchorPoint(0.5, 0.5);
        content.setContentSize2(styles);
        content.addChild(text);
        text.setAlignment(content.width / 2, content.height / 2);

        this._super({
            title: Messages.get("LeaguesUpgradeWindow.Title"),
            name: "LeaguesUpgradeWindow",
            content,
            closeButton: false,
            fireworks: true,
            button: {
                width: styles.button.width,
                height: styles.button.height,
                text: Messages.get("OK"),
                onClicked: this.close.bind(this)
            }
        });
    },

    getPerson: function () {
        return {
            role: "hero",
            emotion: "happy"
        };
    },

    createText: function () {
        const styles = cleverapps.styles.LeaguesUpgradeWindow;

        const league = cleverapps.leagues.league;

        const text = cleverapps.UI.generateOnlyText(Messages.get("LeaguesUpgradeWindow.text", {
            league: Messages.get(`League${league}`)
        }), cleverapps.styles.FONTS.WINDOW_TEXT);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        text.setDimensions(styles.width, 0);
        text.fitTo(undefined, styles.height);

        return text;
    }
});

cleverapps.styles.LeaguesUpgradeWindow = {
    width: 550,
    height: 500,

    button: {
        width: 280,
        height: 110
    }
};
